<app-basic-select [options]="['FEMALE', 'MALE']" [(ngModel)]="localValue" [title]="title" [iconClass]="'gender-ambiguous fw-bold'" (ngModelChange)="onValueChange($event)"></app-basic-select>
